import {atom} from "jotai";
import {ScoutingNote} from "../types/scoutingNote";

export const activeMapFeatureAtom = atom<ScoutingNote | null>(null);
